import { render, staticRenderFns } from "./IconSeminar.vue?vue&type=template&id=a197c14a&scoped=true&"
import script from "./IconSeminar.vue?vue&type=script&lang=js&"
export * from "./IconSeminar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a197c14a",
  null
  
)

export default component.exports